import { NgModule } from '@angular/core';

import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { IAuthService } from './auth/services/iauth.service';
import { CoreModule } from './core/core.module';
import { AuthService } from './seguranca/auth.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    AuthModule.forRoot(
      {
        theme: {
          logoUrl: environment.configuracaoThema.logoLogin,
          siteUrl: environment.configuracaoThema.site,
          appName: environment.configuracaoThema.name,
        },
        features: {
          enableRegistration: environment.controlaAssinatura,
          enablePasswordReset: true,
        },
      },
      { provide: IAuthService, useClass: AuthService }
    ),
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
